import useSWR, {SWRConfiguration} from 'swr';
import heartbeatAPI from '../axiosInstance';

export function useNetworkHeartbeat(SWRConfig?: SWRConfiguration) {
  return useSWR(
    '/favicon.ico',
    (url) => heartbeatAPI(url).then((res) => res.data),
    {
      refreshInterval: 10000,
      shouldRetryOnError: true,
      errorRetryCount: Infinity,

      ...SWRConfig,
    },
  );
}
